import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GoogleLogin } from '@react-oauth/google';
import { googleLogin } from '../redux/slices/authSlice';
import { fetchLoginBanner, clearError } from '../redux/slices/bannerSlice';
import LottiePlayer from './LottiePlayer';


const LoginPopup = ({ isOpen, onClose }) => {
    const dispatch = useDispatch();
    const { loginBanner, loading, error } = useSelector((state) => state.banner);

    useEffect(() => {
        if (isOpen) {
            dispatch(fetchLoginBanner());
        }
        return () => dispatch(clearError());
    }, [dispatch, isOpen]);

    if (!isOpen) return null;

    const defaultImage = 'https://images.unsplash.com/photo-1683009427666-340595e57e43?q=80&w=2070&auto=format&fit=crop';

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-custom-white rounded-lg w-full max-w-3xl flex flex-col md:flex-row relative">
                {/* Left Section */}
                <div className="w-full md:w-1/2 flex items-center justify-center text-custom-white p-8">
                    {loading ? (
                        <div className="flex items-center justify-center w-full h-full">

                            <LottiePlayer
                                src="https://lottie.host/b2b25f7e-1811-405a-9986-2d09791950ef/8cJ75x5MYO.lottie"
                                width={300}
                                height={300}
                            />

                        </div>
                    ) : error || !loginBanner ? (
                        <div
                            className="w-full h-full bg-cover bg-center flex items-center justify-center text-center"
                            style={{ backgroundImage: `url("${defaultImage}")` }}
                        >
                            <p className="text-lg font-medium">
                                {error || 'No login banner available'}
                            </p>
                        </div>
                    ) : (
                        <div
                            className="w-full h-full bg-cover bg-center flex items-center justify-center text-center"
                            style={{ backgroundImage: `url("${loginBanner.imageUrl}")` }}
                        >
                            <div>
                                <h1 className="text-3xl md:text-4xl font-bold mb-4">Your Adventure Starts Here</h1>
                                <p className="text-md md:text-lg">
                                    Experience 20,000+ Tours and Activities from 1,200+ Suppliers
                                </p>
                            </div>
                        </div>
                    )}
                </div>

                {/* Right Section - Google Login */}
                <div className="w-full md:w-1/2 p-8 relative flex flex-col min-h-[28rem]">
                    <button
                        onClick={onClose}
                        className="absolute top-4 right-4 text-custom-blue hover:text-custom-yellow"
                    >
                        ✕
                    </button>

                    {/* Form Title */}
                    <h2 className="text-2xl font-semibold mb-6 text-custom-blue">Log into Your Account</h2>

                    {/* Google Login Button */}
                    <GoogleLogin
                        onSuccess={(credentialResponse) => {
                            const token = credentialResponse.credential;
                            dispatch(googleLogin(token));
                            onClose();
                        }}
                        onError={() => {
                            console.error("Google login failed");
                        }}
                        theme="filled_blue"
                        size="large"
                        shape="pill"
                    />

                    <div className="flex-grow"></div>

                    <div className="mt-6 text-center">
                        <p className="text-sm font-semibold mb-4">Book With Confidence</p>
                        <div className="grid grid-cols-2 gap-6 justify-items-center">
                            <div className="flex flex-col items-center gap-1">
                                <img src="https://www.tripadvisor.com/favicon.ico" alt="TripAdvisor" className="w-5 h-5" />
                                <span className="text-xs text-gray-500">TRIP ADVISOR</span>
                                <span>4.5/5</span>
                            </div>
                            <div className="flex flex-col items-center gap-1">
                                <img src="https://www.trustpilot.com/favicon.ico" alt="TrustPilot" className="w-5 h-5" />
                                <span className="text-xs text-gray-500">TRUST PILOT</span>
                                <span>4.0/5</span>
                            </div>
                            <div className="flex flex-col items-center gap-1">
                                <img src="https://www.google.com/favicon.ico" alt="Google" className="w-5 h-5" />
                                <span className="text-xs text-gray-500">GOOGLE</span>
                                <span>4.4/5</span>
                            </div>
                            <div className="flex flex-col items-center gap-1">
                                <img src="https://via.placeholder.com/20" alt="Reviews.io" className="w-5 h-5" />
                                <span className="text-xs text-gray-500">REVIEWS.IO</span>
                                <span>4.3/5</span>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default LoginPopup;